export default __webpack_public_path__ + "static/media/34_photo.3092bb5f.jpg";